<template>
	<div v-click-outside="() => isOpenOptions = false" class="dropdown-custom position-rel type-question">
		<div class="dropdown-custom__display" @click="() => isOpenOptions = !isOpenOptions"><span v-html="titleDefault"></span> <i class="icon-arrow-down"></i></div>
		<div class="dropdown-custom__options" v-show="isOpenOptions">
			<!-- <div class="item" value="" @click="chooseVal">{{ nameOptionDefault }}</div> -->
			<div class="item" v-for="(item, index) of options" :value="item[optionValueKey]" :key="index" @click="chooseVal(item)">
				<span v-html="item[optionNameKey]"></span>
			</div>
		</div>
	</div>
</template>

<script>
	import ClickOutside from 'vue-click-outside'

	export default {
		name: 'DropdownCustom',
		props: {
			nameOptionDefault: String,
			valoptionActive: Number,
			options: Array,
			optionValueKey: String,
			optionNameKey: String,
			location: Number,
			position: Number,
			type: String
		},
		directives: {
		    ClickOutside
		},
		data () {
			return {
				titleDefault: '?',
				valActive: '',
				isOpenOptions: false
			}
		},
		created() {
			this.setValDefault();
		},
		methods: {

			setValDefault() {
				if(this.options) {
					this.titleDefault = this.nameOptionDefault ? this.nameOptionDefault : this.options[0][this.optionNameKey]
					this.valActive = this.valoptionActive ? this.valoptionActive : this.options[0][this.optionValueKey];
				}
			},

			chooseVal(val = null) {
				// console.log('Choose answer: ', val);
				this.titleDefault = val ? val[this.optionNameKey] : this.nameOptionDefault;
				this.valActive = val ? val[this.optionValueKey] : '';
				let positionAnswerChoose = val.position.split('_');
				// console.log(positionAnswerChoose);
				this.isOpenOptions = false;
				// let valEmit = {evt: {target: {value: this.valActive}}, location: this.location, index: this.position, type: this.type, nameChoose: this.titleDefault, valChoose: this.valActive};
				let valEmit = {evt: {target: {value: this.valActive}}, location: positionAnswerChoose[0], index: positionAnswerChoose[1], position_display: this.position, type: this.type, nameChoose: this.titleDefault, valChoose: this.valActive};
				this.$emit('changeSelect', valEmit)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./../assets/scss/_mixins";
	@import "./../assets/scss/_variables";
	@import "./../assets/scss/_general";

	.dropdown-custom {

		&__display {
			@extend .position-rel;
			@extend .border-rd-4;
			border: 1px solid #ccc;
			@extend .text-center;
			height: 30px;
			min-width: 100px;
			@extend .bg-color-light;
			padding: 0 20px 0 3px;
    		overflow: hidden;

			i {
				position: absolute;
				top: 0;
				right: 0;
				width: 30px;
				height: inherit;
				@extend .display-flex-center;
				@extend .justify-content-center;
				@extend .font-size-10;
				@extend .secondary-color-txt;
			}
		}

		&__options {
			position: absolute;
			top: 100%;
			left: 0;
			right: 0;
			box-shadow: 0 1px 10px rgba(0,0,0, .1);
			-webkit-box-shadow: 0 1px 10px rgba(0,0,0, .1);
			@extend .bg-color-light;
			z-index: 2;

			.item {
				padding: 5px 10px;
			}
		}

		&.error {
			.dropdown-custom__display {
				border-color: $color_err_question;
			}
		}

		&.success {
			.dropdown-custom__display {
				border-color: $color_success;
			}
		}

		@media screen and ( max-width: 600px ) {
			&__display {
				min-width: 80px;
			}
		}
	}
</style>